import React, { useEffect } from 'react';
import { Download, Settings, CheckCircle } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const Installation = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('installation');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'Fresh Installation',
      icon: Download,
      description: 'Step-by-step guides and scripts for new SQL Server installations and setup.',
      scripts: getContentByCategory('Installation', 'Fresh Installation')
    },
    {
      name: 'Configuration',
      icon: Settings,
      description: 'Post-installation configuration scripts and best practice settings.',
      scripts: getContentByCategory('Installation', 'Configuration')
    },
    {
      name: 'Validation',
      icon: CheckCircle,
      description: 'Installation validation scripts and health checks for new deployments.',
      scripts: getContentByCategory('Installation', 'Validation')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Installation</h1>
        <p className="page-description">
          Complete SQL Server installation guides, configuration scripts, and validation procedures. 
          Ensure proper setup and optimal configuration for new deployments.
        </p>
      </div>

      <CategoryTabs 
        category="Installation"
        scripts={getContentByCategory('Installation')}
        articles={getContentByCategory('Installation', null, 'articles')}
        faqs={getContentByCategory('Installation', null, 'faqs')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default Installation;